export const CHECKOUT_TOMO_1 = 'https://www.valux.site/cart/51557297324338:1';
export const CHECKOUT_SISTEMA_COMPLETO = 'https://www.valux.site/cart/51557301289266:1';
export const heroBadges = ['📄 100% PDF', '⚡ Acceso en 5 min', '📦 Mayoristas · Fabricantes'];
export const heroTrust = ['🛡️ Garantía 7 días', '🔒 Pago seguro', '💳 Mercado Pago', '💳 Tarjeta'];
export const stats = [{
  value: '+200',
  label: 'Mayoristas activos'
}, {
  value: '2',
  label: 'Tomos completos'
}, {
  value: '10',
  label: 'Bonos incluidos'
}, {
  value: '4.9 ⭐',
  label: 'Calificación'
}];
export const heroTestimonials = [{
  initials: 'MG',
  quote: '"Implementé el Filtro CUIT y en una semana dejé de perder 3 horas por día con gente que nunca iba a comprar. El ROI fue inmediato."',
  author: '— Marcelo G., Córdoba · Distribuidora de insumos'
}, {
  initials: 'LP',
  quote: '"Los Scripts de Cierre de Acero me cambiaron la operación. Antes bajaba el precio siempre. Ahora cierro sin ceder un peso."',
  author: '— Laura P., Rosario · Importadora mayorista'
}, {
  initials: 'RM',
  quote: '"Con el Tomo 2 armé mis primeras campañas de Meta Ads y en el primer mes recuperé 10 veces lo que pagué por el sistema."',
  author: '— Roberto M., Buenos Aires · Fabricante textil'
}];
export const painPoints = ['Respondés "precio" 40 veces por día a personas sin CUIT ni intención real de compra.', 'Bajás el precio ante la primera objeción sin saber si realmente era necesario.', 'Meta te bloquea el número sin aviso y perdés 10 años de contactos comerciales.', 'Tus clientes del interior no te conocen porque nunca llegaste a ellos de forma sistemática.', 'Tu competencia te gana porque cierra mejor, no porque sea mejor proveedor.', 'El lunes empieza con los mismos chats sin cerrar del viernes. El ciclo se repite.'];
export const levelPills = ['Filtro CUIT', 'Scripts de cierre', 'Anti-Ban 2026', 'Meta Ads B2B', 'Escala federal', 'Automatización'];
export const volumes = [{
  icon: '📘',
  title: 'TOMO 1 — Método Despacho Inmediato',
  tag: 'Front-End',
  description: 'La re-ingeniería completa de tu WhatsApp Business. Filtro CUIT, scripts de cierre, catálogo dinámico y blindaje Anti-Ban.'
}, {
  icon: '🚀',
  title: 'TOMO 2 — El Acelerador de Escala Nacional',
  tag: 'Upsell',
  description: 'Meta Ads B2B, estrategia de expansión federal, delegación blindada y el circuito de reinversión compuesto.'
}];
export const volumeIncludes = ['Scripts de cierre listos para usar', 'Protocolos de calificación de clientes', 'Checklists de implementación diaria', 'Tablas de métricas y control operativo', 'Casos reales del mercado argentino', 'Plan de acción de 7 días', '100% adaptado a WhatsApp 2026', 'Alineado a Meta Ads Argentina 2026'];
export const bonuses = [{
  number: '01',
  label: '🎯 BONO 1',
  title: 'Scripts Cierre de Acero',
  description: 'Audios de 15 segundos para liquidar la objeción "está caro" sin bajar el precio.',
  price: '$8.000'
}, {
  number: '02',
  label: '🔍 BONO 2',
  title: 'Protocolo Filtro CUIT',
  description: 'Blindaje total contra espías y consumidores finales. Calificación en 45 segundos.',
  price: '$9.000'
}, {
  number: '03',
  label: '📋 BONO 3',
  title: 'Catálogo Gamma-Ready',
  description: 'Estructura visual de alta rotación para tus listas de precios.',
  price: '$8.000'
}, {
  number: '04',
  label: '🛡️ BONO 4',
  title: 'WhatsApp Anti-Ban 2026',
  description: 'Configuración técnica para operar sin riesgo de bloqueo de Meta.',
  price: '$10.000'
}, {
  number: '05',
  label: '⚡ BONO 5',
  title: 'Operativo Resucitación',
  description: 'Recuperá clientes inactivos de los últimos 90 días en menos de 24 horas.',
  price: '$9.000'
}, {
  number: '06',
  label: '🔗 BONO 6',
  title: 'Sync B2B Shopify',
  description: 'Automatización de stock y cobro directo desde el chat. Cero errores manuales.',
  price: '$10.000'
}, {
  number: '07',
  label: '📢 BONO 7',
  title: 'Biblioteca de Copies B2B',
  description: '5 sets de anuncios para Meta Ads listos para copiar y publicar hoy.',
  price: '$12.000'
}, {
  number: '08',
  label: '🖥️ BONO 8',
  title: 'Plantilla Landing Page',
  description: 'Estructura completa para Magic Patterns con copy B2B incluido.',
  price: '$11.000'
}, {
  number: '09',
  label: '📊 BONO 9',
  title: 'Tracker de Métricas Semanal',
  description: 'Planilla exacta para medir ROAS y CPA sin perderse en los datos.',
  price: '$8.000'
}, {
  number: '10',
  label: '🤝 BONO 10',
  title: 'Protocolo Onboarding Distribuidor',
  description: 'El proceso completo para cerrar distribuidores del interior del país.',
  price: '$10.000'
}];
export const plans = [{
  icon: '📘',
  name: 'OPCIÓN 1 — MÉTODO DESPACHO INMEDIATO',
  shortName: 'MÉTODO DESPACHO INMEDIATO',
  includes: 'Tomo 1 + 6 Bonos',
  finalIncludes: 'Tomo 1 + 6 Bonos · Todos los niveles de operación',
  idealFor: 'Mayoristas que quieren ordenar su WhatsApp hoy.',
  oldPrice: '$51.000 ARS',
  price: '$19.990 ARS',
  cta: '→ QUIERO EL TOMO 1',
  href: CHECKOUT_TOMO_1,
  featured: false
}, {
  icon: '🏆',
  name: 'OPCIÓN 2 — SISTEMA DESPACHO TOTAL™',
  shortName: 'SISTEMA DESPACHO TOTAL™ ⭐',
  includes: 'Tomo 1 + Tomo 2 + 10 Bonos',
  finalIncludes: 'Tomo 1 + Tomo 2 + 10 Bonos · Sistema completo de orden y escala',
  idealFor: 'Mayoristas que quieren clientes nuevos de todo el país.',
  oldPrice: '$69.000 ARS',
  price: '$27.990 ARS',
  cta: '→ QUIERO EL SISTEMA COMPLETO',
  href: CHECKOUT_SISTEMA_COMPLETO,
  featured: true
}];
export const kitRows = [{
  without: 'Dependés solo de tu red actual',
  with: 'Meta Ads trae dueños de locales todos los días'
}, {
  without: 'Sin sistema para capturar distribuidores del interior',
  with: 'Expansión activa en 8 provincias prioritarias'
}, {
  without: 'No podés delegar sin riesgo de perder la base',
  with: 'Sistema blindado para delegar sin perder los contactos'
}, {
  without: 'No sabés cuándo ni cuánto escalar',
  with: 'Circuito del 20% que crece de forma compuesta'
}];
export const testimonials = [{
  initials: 'CR',
  name: 'Carlos R.',
  meta: '📍 Mendoza | Sistema Completo',
  quote: '"El Sistema de Etiquetas me dio el CRM que nunca tuve. Por fin sé exactamente en qué estado está cada cliente."'
}, {
  initials: 'SA',
  name: 'Sebastián A.',
  meta: '📍 Buenos Aires | Tomo 1',
  quote: '"El Anti-Ban me salvó la cuenta. Tenía el número caliente y no lo sabía. Ahora opero tranquilo."'
}, {
  initials: 'PV',
  name: 'Patricia V.',
  meta: '📍 Rosario | Sistema Completo',
  quote: '"Con el Protocolo de Distribuidor cerré dos clientes en Tucumán y uno en Neuquén en el primer mes."'
}];
export const faqs = [{
  question: '¿Sirve para cualquier rubro mayorista?',
  answer: 'Sí. Es ingeniería operativa, no de producto específico. Funciona para textil, ferretería, insumos, electrónica, alimentos y cualquier rubro que opere con volumen mayorista en Argentina.'
}, {
  question: '¿Cómo recibo el material?',
  answer: '100% digital. Acceso por email en menos de 5 minutos después del pago. Todo en PDF descargable y guardable.'
}, {
  question: '¿Necesito tener Shopify?',
  answer: 'No es obligatorio. El 80% del sistema funciona solo con WhatsApp Business. El Bono 6 es para los que ya tienen Shopify o quieren sumarlo. No es requisito.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. 7 días de garantía total. Escribís a soporte.valux@gmail.com y te devolvemos el 100% sin preguntas.'
}, {
  question: '¿Cuánto tiempo lleva implementarlo?',
  answer: 'El plan de 7 días del Tomo 1 es de 1 hora por día. El perfil y los mensajes automáticos se configuran el Día 1 en menos de 2 horas.'
}];
export const costRows = [{
  without: '3 hs de chats sin conversión por día × 5 días',
  cost: '15 horas de tu tiempo por semana'
}, {
  without: 'Bajar el precio ante cada objeción sin script',
  cost: 'Margen destruido sin datos'
}, {
  without: 'Sin Anti-Ban: número bloqueado por Meta',
  cost: 'Riesgo de perder toda la base de contactos'
}, {
  without: 'Sin estrategia federal activa',
  cost: 'Mercado artificialmente limitado'
}, {
  without: 'El próximo lunes igual que este',
  cost: 'El mismo ciclo, el próximo año'
}];
export const footerTrust = ['🔒 Pago 100% seguro', '⚡ Acceso en 5 minutos', '🛡️ Garantía 7 días', '💳 Mercado Pago · Tarjeta'];
export const footerLinks = [{
  icon: '📧',
  label: 'soporte.valux@gmail.com',
  href: 'mailto:soporte.valux@gmail.com'
}, {
  icon: '📲',
  label: '@valux.oficial',
  href: 'https://instagram.com/valux.oficial'
}, {
  icon: '👍',
  label: 'Facebook VALUX™',
  href: 'https://facebook.com'
}, {
  icon: '🌐',
  label: 'www.valux.site',
  href: 'https://www.valux.site'
}];
export const liveNotifications = [{
  name: 'Martín R.',
  city: 'Buenos Aires',
  product: 'Sistema Despacho Total',
  time: 'hace 2 minutos'
}, {
  name: 'Lucía F.',
  city: 'Córdoba',
  product: 'Método Despacho Inmediato',
  time: 'hace 6 minutos'
}, {
  name: 'Diego S.',
  city: 'Rosario',
  product: 'Sistema Despacho Total',
  time: 'hace 11 minutos'
}, {
  name: 'Valeria M.',
  city: 'Mendoza',
  product: 'Sistema Despacho Total',
  time: 'hace 17 minutos'
}, {
  name: 'Hernán T.',
  city: 'Tucumán',
  product: 'Método Despacho Inmediato',
  time: 'hace 23 minutos'
}];